




































































































































































































































































import Porlet from '@/models/Porlet';
import Entidad from '@/models/Entidad';
import Currency from '@/components/Currency.vue';
import BarChart from '@/components/Bar.vue';
// import axios from 'axios';
export default {
	name: 'dashboard',
	inject: ['responsive'],
	components: {
		Currency,
		BarChart,
	},
	data() {
		return {
			config: [],
			cuit: this.$store.state.config.cuit,
			publicPath: process.env.BASE_URL,
			//tableResumenGranosFilter: [],
			//profiles: [],
			value1: false,
			window: '',
			loadingDashboard: false,
			searchValue: '',
		};
	},
	computed: {
		isMobile(): boolean {
			return this.window.innerWidth < 480 ? true : false;
		},
		porlets(): Porlet[] {
			return this.$store.state.dashboard.porlets;
		},
		//TODO: Refactor
		tableResumenGranos: {
			get() {
				return this.$store.state.dashboard.tableResumenGranos;
			},
			set(value) {
				this.tableResumenGranos = value;
			},
		},
		counttableResumenGranos(): number {
			return this.$store.state.dashboard.tableResumenGranos.length;
		},
		activeProfile(): string {
			return this.$store.state.perfil.activeProfile ? this.$store.state.perfil.activeProfile : this.$route.path.slice(1, 2);
		},
		entidadSelected(): Entidad | false {
			return this.$store.state.perfil.entidadSelected ? this.$store.state.perfil.entidadSelected : false;
		},
		entidades(): Entidad[] {
			return this.$store.state.dashboard.entidades;
		},
		profiles() {
			return this.$store.state.perfil.userdata.perfiles;
		},
	},
	methods: {
		changeSwitch(valor): void {
			this.$store.dispatch('changeSwitch', valor);
		},
		numberFormatter(row, column, cellValue): string {
			var formatter = new Intl.NumberFormat('es-AR', {
				style: 'decimal',
				maximumFractionDigits: 0,
				minimumFractionDigits: 0,
			});
			return formatter.format(cellValue);
		},
		update(data): void {
			setTimeout(() => {
				this.$router.push(`/${data.value}`);
			}, 200);
		},
		openLink(link: string): void {
			if (link.indexOf('http') < 0) this.$router.push('/' + this.activeProfile + link);
			else window.open(link);
		},
		clickResumenGrano(row): void {
			this.$router.push(`/${this.$route.path.slice(1, 2)}/granos/${row.cereal}/${row.cosecha}`);
		},
	},
	watch: {
		$route(newId, oldId) {},
	},
	mounted() {
		this.$store.dispatch('loadConfig').then(cfg => {
			this.config = cfg;
		});
		this.window = window;
		this.loadingDashboard = true;
		this.$store
			.dispatch('loadPorlets', {
				url: 'etenet_dashboard',
			})
			.then(() => {
				this.value1 = true;
				this.changeSwitch(this.value1);
				this.loadingDashboard = false;
			});
	},
};
